import AppContainer from '../basicLayout/AppContainer';
export default [
  {
    path: '/platformSys',
    name: 'platform_sys_management',
    component: AppContainer,
    meta: {
      title: '系统管理',
    },
    children: [
      {
        path: 'platformDept',
        name: 'PlatformDept',
        meta: {
          title: '部门管理',
        },
        component: (resolve) =>
          require(['@/views/platform/sys/org/index.vue'], resolve),
      },
      {
        path: 'platformRole',
        meta: {
          title: '角色管理',
        },
        name: 'PlatformRole',
        component: (resolve) =>
          require(['@/views/platform/sys/role/index.vue'], resolve),
      },

      {
        path: 'platformUser',
        meta: {
          title: '用户管理',
        },
        name: 'PlatformUser',
        component: (resolve) =>
          require(['@/views/platform/sys/user/index.vue'], resolve),
      },
      {
        path: 'platformPost',
        meta: {
          title: '岗位管理',
        },
        name: 'PlatformPost',
        component: (resolve) =>
          require(['@/views/platform/sys/post/index.vue'], resolve),
      },
      {
        path: 'platformDict',
        meta: {
          title: '字典管理',
        },
        name: 'PlatformDict',
        component: (resolve) =>
          require(['@/views/platform/sys/dict/index.vue'], resolve),
      },
    ],
  },
  {
    path: '/platformInformation',
    name: 'platform_information_management',
    component: AppContainer,
    meta: {
      title: '资料管理',
    },
    children: [
      {
        path: 'platformRealNameAuthentication',
        meta: {
          title: '实名认证',
        },
        name: 'PlatformRealNameAuthentication',
        component: (resolve) =>
          require([
            '@/views/platform/information/realNameAuthentication/index.vue',
          ], resolve),
      },
      {
        path: 'platformDriverCertification',
        meta: {
          title: '驾驶员认证',
        },
        name: 'PlatformDriverCertification',
        component: (resolve) =>
          require([
            '@/views/platform/information/driverCertification/index.vue',
          ], resolve),
      },
      {
        path: 'platformVehicleCertification',
        meta: {
          title: '司机认证',
        },
        name: 'PlatformVehicleCertification',
        component: (resolve) =>
          require([
            '@/views/platform/information/vehicleCertification/index.vue',
          ], resolve),
      },
      {
        path: 'platformcapaCityCertification',
        meta: {
          title: '运力认证',
        },
        name: 'PlatformcapaCityCertification',
        component: (resolve) =>
          require([
            '@/views/platform/information/capacityCertification/index.vue',
          ], resolve),
      },
    ],
  },
  {
    path: '/platformSupply',
    name: 'platform_supply',
    component: AppContainer,

    meta: {
      title: '货源管理',
    },
    children: [
      {
        path: 'platformSupplyList',
        meta: {
          title: '货源列表',
        },
        name: 'PlatformSupplyList',
        component: (resolve) =>
          require(['@/views/platform/supply/index.vue'], resolve),
      },
    ],
  },
];
